import { Td, Tr } from '@aloft/toolkit-sui';

export const DepreciationHeaderRow = () => (
  <Tr>
    <Td>Less</Td>
    <Td colSpan={2}>Physical</Td>
    <Td colSpan={2}>Functional</Td>
    <Td colSpan={2}>External</Td>
    <Td />
  </Tr>
);
